import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { astrologerInfo } from '../mock';

export const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show button after a small delay for better UX
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Auto-show tooltip for first-time visitors
    if (isVisible) {
      const tooltipTimer = setTimeout(() => {
        setShowTooltip(true);
        setTimeout(() => setShowTooltip(false), 5000);
      }, 2000);

      return () => clearTimeout(tooltipTimer);
    }
  }, [isVisible]);

  const handleWhatsAppClick = () => {
    const phoneNumber = astrologerInfo.phone.replace(/[^0-9]/g, '');
    const message = encodeURIComponent('Hello! I would like to consult with Pandith Gangadhar Shastri regarding astrology services.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
        {/* Tooltip */}
        {showTooltip && (
          <div className="bg-white shadow-2xl rounded-lg p-4 max-w-xs animate-slideInRight relative">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            >
              <X size={16} />
            </button>
            <p className="text-sm text-gray-800 font-medium mb-1">
              Need Guidance? Chat with us!
            </p>
            <p className="text-xs text-gray-600">
              Get instant astrological consultation via WhatsApp
            </p>
          </div>
        )}

        {/* Main WhatsApp Button */}
        <button
          onClick={handleWhatsAppClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 animate-bounce-slow"
          aria-label="Chat on WhatsApp"
        >
          {/* Pulse Animation */}
          <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
          
          {/* WhatsApp Icon */}
          <div className="relative z-10">
            <MessageCircle size={32} className="group-hover:rotate-12 transition-transform duration-300" />
          </div>

          {/* Badge for new messages indicator */}
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center animate-pulse">
            1
          </span>
        </button>

        {/* Text Label */}
        <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium shadow-lg animate-slideInRight">
          Chat with us
        </div>
      </div>

      {/* Mobile Bottom Bar Alternative (Optional - shows on very small screens) */}
      <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-green-500 text-white p-3 shadow-lg">
        <button
          onClick={handleWhatsAppClick}
          className="w-full flex items-center justify-center gap-2 font-semibold"
        >
          <MessageCircle size={24} />
          <span>WhatsApp Us Now - Available 24/7</span>
        </button>
      </div>
    </>
  );
};
